import { render } from "./FormationPage.vue?vue&type=template&id=786a276e&scoped=true"
import script from "./FormationPage.vue?vue&type=script&lang=js"
export * from "./FormationPage.vue?vue&type=script&lang=js"

import "./FormationPage.vue?vue&type=style&index=0&id=786a276e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-786a276e"]])

export default __exports__